import React, { Fragment, useEffect, useState } from "react";
import HttpService from "../../services/httpService";
import { setLoading, setSnackInfo } from "../../redux/actions/appAction";
import { connect } from "react-redux";
import {
  Paper, Dialog, DialogActions, DialogContent, DialogTitle, Table, TableBody, TableCell, TableContainer, TableRow, TableHead, TextField, Typography, Accordion, AccordionSummary, AccordionDetails, Card,
  CardActionArea,
  CardMedia,
  CardContent,
  CardActions,
} from '@material-ui/core';
import CenterFocusWeakIcon from '@material-ui/icons/CenterFocusWeak';
import { makeStyles } from "@material-ui/core/styles";
import { Button } from "antd";
import { CSVLink } from "react-csv";
import moment from "moment";
import { ROLENAME } from "../../utils/index";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { withStyles } from "@material-ui/core/styles";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import LockIcon from '@material-ui/icons/Lock';
import { Modal, Tooltip } from "antd";
import InfoIcon from "@material-ui/icons/Info";
import { DownloadOutlined } from '@ant-design/icons';
import SalesUserLeadMetrics from "../SalesUserLeadMetrics";
import LeadFromMeetingToOrder from "../../components/LeadFromMeetingToOrder";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    "& > * + *": {
      marginTop: theme.spacing(2),
    },
  },
  bordercolors: {
    border: "1px solid #eee5e5",
    background: "#1C375D",
  },
  handOnHover:{
    cursor: "pointer"
  },
  cardDialog: {
    minWidth: "80%",
    cursor: 'default'
  },
  table: {
    minWidth: 700,
  },
  tableHeaderCell: {
    backgroundColor: '#f0f8ff',
    fontWeight: 'bold',
  },
  heading:{
    fontWeight: '600',
    fontSize: '17px',
  },
  tableBackground:{
    backgroundColor:'red'
  }, 
  root: {
    width: "100%",
  },
  title: {
    fontSize: 14,
  },
  customTableContainer: {
    overflowX: "initial",
  },
  pos: {
    marginBottom: 12,
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: "center",
    color: theme.palette.text.secondary,
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginpivotRight: theme.spacing(1),
    width: 200,
  },
  table: {
    width: "fit-content",
  },
  csv: {
    display: "flex",
    alignItems: "center",
    marginBottom: 20,
  },
  report: {
    marginBottom: 20,
    alignItems: "center",
    justifyContent: "center",
  },
  leadSearchButton: {
    backgroundColor: "#b7ccf7",
    color: "#151921",
    padding: "1",
    marginRight: "0.5em",
    borderRadius: "20px",
    width: "20%",
    "&:hover": { backgroundColor: "#14419c", color: "white" },
  },
  leadClearButton: {
    backgroundColor: "#f7b7b7", // light red background
    color: "#151921",
    padding: "1",
    marginRight: "0.5em",
    borderRadius: "20px",
    width: "20%",
  },
  cellStyle: {
    padding: 10,
    width: 500,
    textAlign: "center",
    fontWeight: 700,
    backgroundColor: "#1C375D",
    color: "white",
  },
}));

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: "#1C375D",
    color: "#FFF2EB",
    fontWeight: "500",
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.action.hover,
    },
    "& td, & th": { 
      textAlign: "center",
    },
  },
}))(TableRow);

const SalesUserHomePage = (props) => {
  const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  const classes = useStyles();
  const { userDetails } = useSelector((state) => state.user);
  const [performanceData, setPerformanceData] = useState([]);
  const [dataBasedOnClickAcv, setDataBasedOnClickAcv] = useState([]);
  const [dataBasedOnClickAcvModal, setDataBasedOnClickAcvModal] = useState(false);
  const [taskAssignedData, setTaskAssignedData] = useState();
  const [taskAssignTitleDetail, setTaskAssignTitleDetail] = useState();
  const [taskAssignTitleModal, setTaskAssignTitleModal] = useState(false);
  const [viewConfirmationDialog, setViewConfirmationDialog] = useState(false);
  const [resolveIssueData, setResolveIssueData] = useState({});
  const [remarks, setRemarks] = useState("");
  const [reminderDueData, setReminderDueData] = useState();
  const [reminderDueTitleDetail, setReminderDueTitleDetail] = useState();
  const [reminderDueTitleModal, setReminderDueTitleModal] = useState(false);
  const [reminderTodayData, setReminderTodayData] = useState();
  const [reminderTodaytTitleDetail, setReminderTodaytTitleDetail] = useState();
  const [reminderTodayTitleModal, setReminderTodayTitleModal] = useState(false);
  const [reminderCloseRemark, setReminderCloseRemark] = useState('');
  const [reminderCloseDialog , setReminderCloseDialog] = useState(false);
  const [leadLogId, setLeadLogId] = useState();
  const [leadId, setLeadId] = useState();
  const [taskAssignedNotDueData, setTaskAssignedNotDueData] = useState([]);
  const [taskAssignNotDueTitleDetail, setTaskAssignNotDueTitleDetail] = useState();
  const [taskAssignNotDueTitleModal, setTaskAssignNotDueTitleModal] = useState(false);
  const [reminderTmwData, setReminderTmwData] = useState();
  const [reminderTmwTitleDetail, setReminderTmwTitleDetail] = useState();
  const [reminderTmwTitleModal, setReminderTmwTitleModal] = useState(false);
  const [leadReceivedData, setLeadReceivedData] = useState();
  const [leadReminderNotSetData, setLeadReminderNotSetData] = useState();
  const [projectNotCloseData, setProjectNotCloseData] = useState();
  const [todayTomoExpectedData, setTodayTomoExpectedData] = useState();
  const [close80PerData, setClose80PerData] = useState();
  const [close80TitleDetail, setClose80TitleDetail] = useState();
  const [close80TitleModal, setClose80TitleModal] = useState(false);
  const [cxNotCallData, setCxNotCallData] = useState();
  const [count, setCount] = useState({});
  const [disableMenu, setDisableMenu] = useState({
      taskAssigned: 0,
      reminderDue: 0,
      reminderToday: 0,
      leadReceived: 0
  })
  const [isExpanded, setIsExpanded] = useState({
    taskAssignedExpand: false,
    reminderDueExpand: false,
    reminderTodayExpand: false,
    reminderTomoExpand: false,
    taskAssignedNotDueExpand: false,
    leadReceivedExpand: false,
    leadReminderNotSetExpand: false,
    projectNotCloseExpand: false,
    todayTomoExpectedExpand: false,
    close80PerExpand: false,
    cxNotCallExpand: false,
  });

  useEffect(() => {
    performanceTarget();
    leadReceived();
    taskAssigned();
    reminderDue();
    reminderToday();
    countAllDashboardData();
    reminderTomorrow();
    }, []);

    // const count for All dashboard data =
  const countAllDashboardData = async () => {
    try {
      const obj = {
        userExpCenter: userDetails.experienceCenterId,
      }
      const response = await HttpService.getCountSeDashboardData(obj);
      setCount(response.data);
    } catch (err) {
      console.error(err);
    }
  }
  // performance target function
  const performanceTarget = async () => {
    props.setLoading(true);
    let obj = {
      pivotValue: "performanceTargetSEDashboard",
      userExpCenter: userDetails.experienceCenterId,
      isExpanded: true,
    };
    try {
      let response = await HttpService.performanceVisiabilityForAdmin('',obj.userExpCenter,obj.pivotValue);
      setPerformanceData(response?.data[0]?.data);
    } catch (error) {
      props.setSnackInfo(
        error?.response?.data ?? "Something Went Wrong",
        "error"
      );
    }
    props.setLoading(false);
  };

  // dataBasedOnClickAcvAmount get data based on click amount achieved
  const dataBasedOnClickAcvAmount = async (year, month) => {
    try {
      let obj = {
        year: year,
        month: month
      }
      const res = await HttpService.getDataBasedOnClickAcvAmount(obj);
      setDataBasedOnClickAcv(res?.data);
      setDataBasedOnClickAcvModal(true);
    } catch (error) {
      console.error("error", error);
    }
  };

  // Set Task assigned by Manager Function
  const taskAssigned = async () => {
    props.setLoading(true);
    let obj = {
      pivotValue: "taskAssignd",
      isExpanded: true,
      userExpCenter: userDetails.experienceCenterId,
    };
    try {
      let response = await HttpService.getTaskAssignedData(obj);
      setTaskAssignedData(response.data);
      setDisableMenu(prev => ({...prev, taskAssigned: response.data.length}))
      let localData = JSON.parse(localStorage.getItem('disableMenu'));

      if (!localData || typeof localData !== 'object' || Array.isArray(localData)) {
        localData = { taskAssigned: 0, reminderDue: 0, reminderToday: 0 , leadReceived: 0};
      }
    
      localData.taskAssigned = response.data.length;
      localStorage.setItem('disableMenu', JSON.stringify(localData));
    
    } catch (error) {
      props.setSnackInfo(
        error?.response?.data ?? "Something Went Wrong",
        "error"
      );
      console.log('err',error)
    }
    props.setLoading(false);
  };

  //Task asssigned by manager dashboard 2
  const resolveIssue = (data) => {
    setViewConfirmationDialog(true);
    setResolveIssueData(data);
  };

  const handleCancel = ()=>{
      setViewConfirmationDialog(false);
      setRemarks('');
  }

  // Resolve task assign
  const handleResolveConfirm = async () => {
    try {
        let obj = {
          remarks:remarks,
          createTicketFromNotes: true,
          leadId: resolveIssueData.leadId,
          uniqueTicketNo: resolveIssueData.uniqueTicketNo
        }

      const response = await HttpService.resolveTaskticket(resolveIssueData._id, obj);
      if (response.status === 200) {
        props.setSnackInfo("Internal Ticket Resolved Succesfully", "Success");
        setViewConfirmationDialog(false);
        taskAssigned();
        taskAssignedNotDue();
      }
    } catch (err) {
      console.error(err);
      props.setSnackInfo('Something wents wrong','error');
    }
  };

  // Reminer Due handle Title
  const handleTaskAssignTitle = async (data) => {
    try {      
      setTaskAssignTitleDetail(data);
      setTaskAssignTitleModal(true);
    } catch (error) {
      props.setSnackInfo('Something wents wrong','error');
      console.error("error", error);
    }
  };

 // task assigned not due title 
 const handleTaskAssignNotDueTitle = async (data) => {
  try {      
    setTaskAssignNotDueTitleDetail(data);
    setTaskAssignNotDueTitleModal(true);
  } catch (error) {
    props.setSnackInfo('Something wents wrong','error');
    console.error("error", error);
  }
};

  // Reminder due function
  const reminderDue = async () => {
    props.setLoading(true);
    let obj = {
      pivotValue: "reminderDue",
      isExpanded: true,
      userExpCenter: userDetails.experienceCenterId,
    };
    try {
      let response = await HttpService.getReminderDueData(obj);
      const allRecentNotes = response?.data?.flatMap(item => item.recentNotes);  //flatmap change all objects into a single array (priti)
      setReminderDueData(allRecentNotes);
      setDisableMenu(prev =>({...prev, reminderDue : allRecentNotes.length}));
      let localData = JSON.parse(localStorage.getItem('disableMenu'));

      if (!localData || typeof localData !== 'object' || Array.isArray(localData)) {
        localData = { taskAssigned: 0, reminderDue: 0, reminderToday: 0, leadReceived: 0 };
      }
      
      localData.reminderDue = allRecentNotes.length;
      localStorage.setItem('disableMenu', JSON.stringify(localData));
    } catch (error) {
      props.setSnackInfo(
        error?.response?.data ?? "Something went wrong",
        "error"
      );
      console.log('err',error)
    }
    props.setLoading(false);
  };

  // Reminer Due handle Title
  const handleReminderDueTitle = async (item) => {
    try {
      // const res = await HttpService.getReminderDueTitleDetail(item.leadId);
      setReminderDueTitleDetail(item);
      setReminderDueTitleModal(true);
    } catch (error) {
      console.error("error", error);
    }
  };

  // Reminder Today function
  const reminderToday = async () => {
    props.setLoading(true);
    let obj = {
      pivotValue: "reminderToday",
      isExpanded: true,
      userExpCenter: userDetails.experienceCenterId,
    };
    try {
      let response = await HttpService.getReminderTodayData(obj);
      setReminderTodayData(response.data);
      const allRecentNotes = response?.data?.flatMap(item => item.recentNotes);  //flatmap change all objects into a single array (priti)
      setReminderTodayData(allRecentNotes);
      setDisableMenu(prev=>({...prev, reminderToday : allRecentNotes.length}))
      let localData = JSON.parse(localStorage.getItem('disableMenu'));

      if (!localData || typeof localData !== 'object' || Array.isArray(localData)) {
        localData = { taskAssigned: 0, reminderDue: 0, reminderToday: 0, leadReceived: 0 };
      }
    
      localData.reminderToday = allRecentNotes.length;
      localStorage.setItem('disableMenu', JSON.stringify(localData));
    } catch (error) {
      props.setSnackInfo(
        error?.response?.data ?? "Something went wrong",
        "error"
      );
      console.log('err',error)
    }
    props.setLoading(false);
  };

  // Reminer Today handle Title
  const handleReminderTodayTitle = async (data) => {
    try {
      // const res = await HttpService.getReminderTodayTitleDetail(leadId);
      setReminderTodaytTitleDetail(data);
      setReminderTodayTitleModal(true);
    } catch (error) {
      console.error("error", error);
    }
  };

  // Reminder tomorrow function
  const reminderTomorrow = async () => {
    props.setLoading(true);
    let obj = {
      pivotValue: "reminderTomorrow",
      isExpanded: true,
      userExpCenter: userDetails.experienceCenterId,
    };
    try {
      let response = await HttpService.getReminderTomorrowData(obj);
      const allRecentNotes = response?.data?.flatMap(item => item.recentNotes);  //flatmap change all objects into a single array (priti)
      setReminderTmwData(allRecentNotes);
    } catch (error) {
      props.setSnackInfo(
        error?.response?.data ?? "Something Went Wrong",
        "error"
      );
    }
    props.setLoading(false);
  };

  // handle reminder tomorrow title data in this  function
  const handleReminderTmwTitle = async (data) => {
    try {
      // const res = await HttpService.getReminderTmwTitleDetail(leadId);
      setReminderTmwTitleDetail(data);
      setReminderTmwTitleModal(true);
    } catch (error) {
      console.error("error", error);
    }
  };

  //  handle reminder close submit button 
  const handleReminderCloseButton = async () => {
    props.setLoading(true);
    try {
      let obj = {
        leadId: leadId,
        leadLogId: leadLogId,
        reminderCloseRemark: reminderCloseRemark
      }
      await HttpService.closeReminder(leadLogId, obj);
      reminderDue();
      reminderTomorrow();
      reminderToday();
      setReminderCloseDialog(false);
      setReminderDueTitleModal(false);
      setReminderTmwTitleModal(false);
      setReminderTodayTitleModal(false);
      setReminderCloseRemark('');
      props.setSnackInfo('Reminder Close', 'success');
    }
    catch (err) {
      props.setSnackInfo("Something went wrong", 'error');
    }
    props.setLoading(false);
  }

  const handleClose = (data)=> {
    setLeadId(data.leadId);
    setReminderCloseDialog(true);
    setLeadLogId(data.leadLogId);
  }

    // Set Task assigned by Manager Function
    const taskAssignedNotDue = async () => {
      props.setLoading(true);
      let obj = {
        pivotValue: "taskAssigndNotDue",
        isExpanded: true,
        userExpCenter: userDetails.experienceCenterId,
      };
      try {
        let response = await HttpService.getTaskAssignedNotDueData(obj);
        setTaskAssignedNotDueData(response.data);
      } catch (error) {
        props.setSnackInfo(
          error?.response?.data ?? "Something Went Wrong",
          "error"
        );
      }
      props.setLoading(false);
    };

  // lead Received  function
  const leadReceived = async () => {
    props.setLoading(true);
    let obj = {
      pivotValue: "leadReceived",
      isExpanded: true,
      userExpCenter: userDetails.experienceCenterId,
    };
    try {
      let response = await HttpService.getLeadReceivedData(obj);
      setLeadReceivedData(response.data);

      setDisableMenu(prev =>({...prev, leadReceived : response.data.length}));
      let localData = JSON.parse(localStorage.getItem('disableMenu'));

      if (!localData || typeof localData !== 'object' || Array.isArray(localData)) {
        localData = { taskAssigned: 0, reminderDue: 0, reminderToday: 0, leadReceived: 0 };
      }
      
      localData.leadReceived = response.data.length;
      localStorage.setItem('disableMenu', JSON.stringify(localData));

    } catch (error) {
      props.setSnackInfo(
        error?.response?.data ?? "Something Went Wrong",
        "error"
      );
    }
    props.setLoading(false);
  };

  // lead Reminder Not Set  function
  const leadReminderNotSet = async () => {
    props.setLoading(true);
    let obj = {
      pivotValue: "leadReminderNotSet",
      isExpanded: true,
      userExpCenter: userDetails.experienceCenterId,
    };
    try {
      let response = await HttpService.getLeadReminderNotSetData(obj);
      setLeadReminderNotSetData(response.data);
    } catch (error) {
      props.setSnackInfo(
        error?.response?.data ?? "Something Went Wrong",
        "error"
      );
    }
    props.setLoading(false);
  };

  // project Not Close Data function
  const projectNotClose = async () => {
    props.setLoading(true);
    let obj = {
      pivotValue: "projectNotClose",
      isExpanded: true,
      userExpCenter: userDetails.experienceCenterId,
    };
    try {
      let response = await HttpService.getProjectNotCloseData(obj);
      setProjectNotCloseData(response.data);
    } catch (error) {
      props.setSnackInfo(
        error?.response?.data ?? "Something Went Wrong",
        "error"
      );
    }
    props.setLoading(false);
  };

  // today Tomorrow Expected Data function
  const todayTomoExpected = async () => {
    props.setLoading(true);
    let obj = {
      pivotValue: "todayTomoExpected",
      isExpanded: true,
      userExpCenter: userDetails.experienceCenterId,
    };
    try {
      let response = await HttpService.getTodayTomoExpectedData(obj);
      setTodayTomoExpectedData(response.data);
    } catch (error) {
      props.setSnackInfo(
        error?.response?.data ?? "Something Went Wrong",
        "error"
      );
    }
    props.setLoading(false);
  };

  // close 80 Percent Data function
  const close80Percent = async () => {
    props.setLoading(true);
    let obj = {
      pivotValue: "close80Per",
      isExpanded: true,
      userExpCenter: userDetails.experienceCenterId,
    };
    try {
      let response = await HttpService.getClose80PercentData(obj);
      setClose80PerData(response.data);
    } catch (error) {
      props.setSnackInfo(
        error?.response?.data ?? "Something Went Wrong",
        "error"
      );
    }
    props.setLoading(false);
  };

  // close 80 Percent Data function title detail
  const handleMeetingTitleDetail = async (leadId) => {
    try {
      // const res = await HttpService.getMeetingTitleDetail(leadId);
      const response = await HttpService.getDataForMeetingTracket(leadId)
      const data = response.data
      if (data.success) {
        setClose80TitleDetail(data.meetingLogs);
        // setClose80TitleDetail(data.meetingLogs);
      }
      // setClose80TitleDetail(res?.data);
      setClose80TitleModal(true);
    } catch (error) {
      console.error("error", error);
    }
  };

  // cx Not Call Data function
  const cxNotCall = async () => {
    props.setLoading(true);
    let obj = {
      pivotValue: "cxNotCall",
      isExpanded: true,
      userExpCenter: userDetails.experienceCenterId,
    };
    try {
      let response = await HttpService.getCxNotCallData(obj);
      setCxNotCallData(response.data);
    } catch (error) {
      props.setSnackInfo(
        error?.response?.data ?? "Something Went Wrong",
        "error"
      );
    }
    props.setLoading(false);
  };

  // Handle all expand Data and Table
  const handleAccordionChange = (e, expanded, name) => {
    setIsExpanded({ ...isExpanded, [name]: expanded });
    if (expanded && name === "taskAssignedExpand") {
      taskAssigned();
    } else if (expanded && name === "reminderDueExpand") {
      reminderDue();
    } else if (expanded && name === "reminderTodayExpand") {
      reminderToday();
    } else if (expanded && name === "reminderTomoExpand") {
      reminderTomorrow();
    } else if (expanded && name === "taskAssignedNotDueExpand") {
      taskAssignedNotDue();
    } else if (expanded && name === "leadReceivedExpand") {
      leadReceived();
    } 
     else if (expanded && name === "leadReminderNotSetExpand") {
      leadReminderNotSet();
    } else if (expanded && name === "projectNotCloseExpand") {
      projectNotClose();
    } else if (expanded && name === "todayTomoExpectedExpand") {
      todayTomoExpected();
    } else if (expanded && name === "close80PerExpand") {
      close80Percent();
    } else if (expanded && name === "cxNotCallExpand") {
      cxNotCall();
    }
  };

  const getPerformanceColor = (percentage) => {
    if (percentage === undefined || percentage === null) return "gray"; // Default color
    if (percentage >= 100) return "darkgreen";
    if (percentage >= 80) return "yellow";
    if (percentage < 80) return 'red';
  };

  // '#F50057' - red
  // F47E46 - yellow

  // convert rs in comma saprator
  function formatRupees(amount) {
    const amountInLacs = amount / 100000;
    return new Intl.NumberFormat("en-IN", {
      maximumFractionDigits: 2,
    }).format(amountInLacs);
  }

  return (
    <div className="App">
      {/* <SalesUserLeadMetrics/> */}
      <LeadFromMeetingToOrder/>
      <>
        <Paper className={classes.paper}>
          {/* 1. performance Vs Target */}
          <Accordion expanded={disableMenu.taskAssigned > 0 ? false : true}>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
              id="panel1a-header"
              disabled={disableMenu.taskAssigned > 0 || disableMenu.reminderDue > 0 || disableMenu.reminderToday > 0 || disableMenu.leadReceived > 0}
            >
              <Typography className={classes.heading}>
                Performance Vs target
              </Typography>
            </AccordionSummary>
            <AccordionDetails style={{ padding: 0 }}>
              <TableContainer component={Paper}>
                <Table
                  className={classes.table}
                  stickyHeader
                  aria-label="sticky table"
                >
                  <TableHead>
                    <TableRow>
                      <TableCell className={classes.cellStyle}></TableCell>
                      <TableCell className={classes.cellStyle}>
                        {performanceData[2] &&
                          `${monthNames[performanceData[2].month - 1]} - ${
                            performanceData[2].year
                          }`}
                      </TableCell>
                      <TableCell className={classes.cellStyle}>
                        {performanceData[1] &&
                          `${monthNames[performanceData[1].month - 1]} - ${
                            performanceData[1].year
                          }`}
                      </TableCell>
                      <TableCell className={classes.cellStyle}>
                        {performanceData[0] &&
                          `${monthNames[performanceData[0].month - 1]} - ${
                            performanceData[0].year
                          }`}
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  {/* Performance vs acv target have to table body data */}
                  <TableBody>
                    <TableRow>
                      <TableCell className={classes.cellStyle}>
                        Target
                      </TableCell>
                      <TableCell
                        component="th"
                        style={{ padding: 10, textAlign: "center" }}
                      >
                        {formatRupees(performanceData[2]?.target)}
                      </TableCell>
                      <TableCell
                        component="th"
                        style={{ padding: 10, textAlign: "center" }}
                      >
                        {formatRupees(performanceData[1]?.target)}
                      </TableCell>
                      <TableCell
                        component="th"
                        style={{ padding: 10, textAlign: "center" }}
                      >
                        {formatRupees(performanceData[0]?.target)}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell className={classes.cellStyle}>
                        Achieved(amount)
                      </TableCell>
                      <TableCell
                        component="th"
                        style={{ padding: 10, textAlign: "center", textDecoration: "underline", cursor:'pointer' }}
                        onClick={() => dataBasedOnClickAcvAmount(performanceData[2].year, performanceData[2].month)}
                       >
                        {formatRupees(performanceData[2]?.achieved)}
                      </TableCell>
                      <TableCell
                        component="th"
                        style={{ padding: 10, textAlign: "center", textDecoration: "underline", cursor:'pointer' }}
                        onClick={() => dataBasedOnClickAcvAmount(performanceData[1].year, performanceData[1].month)}
                      >
                        {formatRupees(performanceData[1]?.achieved)}
                      </TableCell>
                      <TableCell
                        component="th"
                        style={{ padding: 10, textAlign: "center", textDecoration: "underline", cursor:'pointer' }}
                        onClick={() => dataBasedOnClickAcvAmount(performanceData[0].year, performanceData[0].month)}
                      >
                        {formatRupees(performanceData[0]?.achieved)}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell className={classes.cellStyle}>
                        Achieved(%)
                      </TableCell>
                      <TableCell
                        component="th"
                        style={{
                          padding: 10,
                          textAlign: "center",
                          backgroundColor: getPerformanceColor(
                            performanceData[2]?.performancePercentage
                          ),
                        }}
                      >
                        {performanceData[2]?.performancePercentage}
                      </TableCell>
                      <TableCell
                        component="th"
                        style={{
                          padding: 10,
                          textAlign: "center",
                          backgroundColor: getPerformanceColor(
                            performanceData[1]?.performancePercentage
                          ),
                        }}
                      >
                        {performanceData[1]?.performancePercentage}
                      </TableCell>
                      <TableCell
                        component="th"
                        style={{
                          padding: 10,
                          textAlign: "center",
                          backgroundColor: getPerformanceColor(
                            performanceData[0]?.performancePercentage
                          ),
                        }}
                      >
                        {performanceData[0]?.performancePercentage}
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            </AccordionDetails>
          </Accordion>

          <Modal
            title="Performance Vs Target Data"
            centered
            visible={dataBasedOnClickAcvModal}
            onCancel={() => setDataBasedOnClickAcvModal(false)}
            width={1000}
            maskClosable={true}
            footer={null}
          >
            {dataBasedOnClickAcv && (
              <TableContainer component={Paper} className={classes.table}>
                <Table
                  style={{ width: 900 }}
                  className={classes.table}
                  stickyHeader
                  aria-label="sticky table"
                >
                  <TableHead>
                    <StyledTableRow>
                      <StyledTableCell>Sl. No.</StyledTableCell>
                      <StyledTableCell>Lead No.</StyledTableCell>
                      <StyledTableCell>Sales Won User</StyledTableCell>
                      <StyledTableCell>Lead Status</StyledTableCell>
                      <StyledTableCell>Lead Won Date</StyledTableCell>
                      <StyledTableCell>Won Amount</StyledTableCell>
                      <StyledTableCell>Design Kick Off Meeting Date</StyledTableCell>
                    </StyledTableRow>
                  </TableHead>
                  <TableBody>
                    {dataBasedOnClickAcv &&
                      dataBasedOnClickAcv.map((item, i) => {
                        return (
                          <>
                            <StyledTableRow key={i}>
                              <StyledTableCell>{i + 1}</StyledTableCell>
                              <StyledTableCell
                                component="th"
                                style={{ textAlign: "center" }}
                              >
                                {item?.lead_no ? (
                                  <Link
                                    to={`/project-logs/${item?._id}`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    style={{
                                      color: "#000",
                                      textDecoration: "underline",
                                      textAlign: "center",
                                    }}
                                  >
                                    {item?.lead_no}
                                  </Link>
                                ) : (
                                  "NA"
                                )}
                              </StyledTableCell>
                              <StyledTableCell
                                component="th"
                                style={{ textAlign: "center" }}
                              >
                                {item?.salesWonUser.name}
                              </StyledTableCell>
                              <StyledTableCell component="th">
                                {item?.leadStatus}
                              </StyledTableCell>
                              <StyledTableCell component="th">
                                {item?.leadWonDate ? moment(item?.leadWonDate).format('DD-MM-YYYY'): '-'}
                              </StyledTableCell>
                              <StyledTableCell component="th">
                                {item?.staticSalesWonAmount}
                              </StyledTableCell>
                              <StyledTableCell component="th">
                                {item?.dateOfDesignKickOffMeeting ? moment(item?.dateOfDesignKickOffMeeting).format('DD-MM-YYYY') : '-'}
                              </StyledTableCell>
                            </StyledTableRow>
                          </>
                        );
                      })}
                  </TableBody>
                </Table>
              </TableContainer>
            )}
          </Modal>

          {(disableMenu.taskAssigned > 0 || disableMenu.reminderDue > 0 || disableMenu.reminderToday > 0 || disableMenu.leadReceived > 0) &&
            <h3 style={{ marginTop: '5px', color: 'black', textAlign: 'left', marginBottom: '3px' }}>
              Note: Please address the overdue tasks in the following table(s) to proceed:
              {disableMenu.leadReceived > 0 ? <span style={{ color: 'red' }}>• Lead Received </span> : ''}
              {disableMenu.taskAssigned > 0 ? <span style={{ color: 'red' }}>• Task Assigned by Manager and Pending </span> : ''}
              {disableMenu.reminderDue > 0 ? <span style={{ color: 'red' }}>• Reminder Due </span> : ''}
              {disableMenu.reminderToday > 0 ? <span style={{ color: 'red' }}>• Reminder Today</span> : ''}. Once cleared, you will gain access to other tasks and tables.
            </h3>
          }
          {/* 7. Lead Received */}
            <Accordion
            expanded={isExpanded.leadReceivedExpand}
            onChange={(event, expanded) =>
              handleAccordionChange(event, expanded, "leadReceivedExpand")
            }
            className={leadReceivedData?.length > 0 ? classes.tableBackground : ''}         
         >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
              id="panel1a-header"
            >
              <Typography className={classes.heading}>
                Lead Received {`(${leadReceivedData?.length})`}
              </Typography>
            </AccordionSummary>
            <AccordionDetails style={{ padding: 0 }}>
              <TableContainer component={Paper}>
                <Table
                  className={classes.table}
                  stickyHeader
                  aria-label="sticky table"
                >
                  <TableHead>
                    <TableRow>
                      <TableCell className={classes.cellStyle}>
                        Sl No.
                      </TableCell>
                      <TableCell className={classes.cellStyle}>
                        Lead no
                      </TableCell>
                      <TableCell className={classes.cellStyle}>
                        Cx Name
                      </TableCell>
                      <TableCell className={classes.cellStyle}>
                        Current Stage
                      </TableCell>
                      <TableCell className={classes.cellStyle}>
                        Lead Created Date
                      </TableCell>
                      <TableCell className={classes.cellStyle}>
                        Last Activity Date
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {leadReceivedData?.length > 0 ? 
                      leadReceivedData?.map((item, index) => (
                        <TableRow key={index}>
                          <TableCell
                            component="th"
                            style={{ padding: 10, textAlign: "center" }}
                          >
                            {index + 1}
                          </TableCell>
                          <TableCell
                            component="th"
                            style={{ padding: 10, textAlign: "center" }}
                          >
                            {item?.lead_no ? (
                              <Link
                                to={`/project-logs/${item?._id}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{
                                  color: "#000",
                                  textDecoration: "underline",
                                  textAlign: "center",
                                }}
                              >
                                {item?.lead_no}
                              </Link>
                            ) : (
                              "NA"
                            )}
                          </TableCell>
                          <TableCell
                            component="th"
                            style={{ padding: 10, textAlign: "center" }}
                          >
                            {item?.customerId?.name}
                          </TableCell>
                          <TableCell
                            component="th"
                            style={{ padding: 10, textAlign: "center" }}
                          >
                            {item?.currentStage}
                          </TableCell>
                          <TableCell
                            component="th"
                            style={{ padding: 10, textAlign: "center" }}
                          >
                            {item?.createdAt ? moment(item?.createdAt).format("DD-MM-YYYY") : '-'}
                          </TableCell>
                          <TableCell
                            component="th"
                            style={{ padding: 10, textAlign: "center" }}
                          >
                            {item?.lastActivityDate? moment(item?.lastActivityDate).format(
                              "DD-MM-YYYY") : '-'}
                          </TableCell>
                        </TableRow>
                      )) : 
                      <TableRow>
                        <TableCell colSpan={6} style={{ textAlign: 'center' }}>No Records Found</TableCell>
                      </TableRow>
                    }
                  </TableBody>
                </Table>
              </TableContainer>
            </AccordionDetails>
          </Accordion>

          {/* 2. Tasks assigned by Managers (ASM/SM/DGM/CH) and due */}
          <Accordion
            expanded={isExpanded.taskAssignedExpand}
            onChange={(event, expanded) =>
              handleAccordionChange(event, expanded, "taskAssignedExpand")
            }
            className={taskAssignedData?.length > 0 ? classes.tableBackground : ''}         
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
              id="panel1a-header"
            >
              <Typography className={classes.heading}>
                Tasks assigned by Managers (ASM/SM/DGM/CH) and Pending {`(${taskAssignedData?.length})`}
              </Typography>
            </AccordionSummary>
            <AccordionDetails style={{ padding: 0 }}>
              <TableContainer component={Paper}>
                <Table
                  className={classes.table}
                  stickyHeader
                  aria-label="sticky table"
                >
                  <TableHead>
                    <TableRow>
                      <TableCell className={classes.cellStyle}>
                        Sl No.
                      </TableCell>
                      <TableCell className={classes.cellStyle}>
                        Lead no
                      </TableCell>
                      <TableCell className={classes.cellStyle}>
                        Cx Name
                      </TableCell>
                      <TableCell className={classes.cellStyle}>
                        Assigned By
                      </TableCell>
                      <TableCell className={classes.cellStyle}>
                        Task Due Date
                      </TableCell>
                      <TableCell colSpan={2} className={classes.cellStyle}>
                        Task Details
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {taskAssignedData?.length > 0 ?
                      taskAssignedData?.map((item, index) => (
                        <TableRow key={index}>
                          <TableCell
                            component="th"
                            style={{ padding: 10, textAlign: "center" }}
                          >
                            {index + 1}
                          </TableCell>
                          <TableCell
                            component="th"
                            style={{ padding: 10, textAlign: "center" }}
                          >
                            {item?.lead_no ? (
                              <Link
                                to={`/project-logs/${item?.leadId}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{
                                  color: "#000",
                                  textDecoration: "underline",
                                  textAlign: "center",
                                }}
                              >
                                {item?.lead_no}
                              </Link>
                            ) : (
                              "NA"
                            )}
                          </TableCell>
                          <TableCell
                            component="th"
                            style={{ padding: 10, textAlign: "center" }}
                          >
                            {item?.customerId?.name}
                          </TableCell>
                          <TableCell
                            component="th"
                            style={{ padding: 10, textAlign: "center" }}
                          >
                            {item?.taskCreatedBy?.name}
                          </TableCell>
                          <TableCell
                            component="th"
                            style={{ padding: 10, textAlign: "center" }}
                          >
                            { item?.expectedClosureDate ? moment(item?.expectedClosureDate).format(
                              "DD-MM-YYYY"
                            ): '-'}
                          </TableCell>
                          <TableCell
                            component="th"
                            onClick={() =>
                              handleTaskAssignTitle(item)
                            }
                            style={{ textAlign: "center", cursor: "pointer", textDecoration: "underline", }}
                          >
                            {item?.ticketTitle}
                          </TableCell>
                          <TableCell component="th">
                             {!(item?.status === "Closed" || item?.status === "Resolved") && (
                                <CenterFocusWeakIcon
                                  className={classes.handOnHover}
                                  style={{ color: '#3299d8' }}
                                  onClick={() => {
                                    resolveIssue(item);
                                  }}
                                  titleAccess="Resolve Issue"
                                />
                             )}
                          </TableCell>
                        </TableRow>
                      ))
                      : 
                      <TableRow>
                        <TableCell colSpan={7} style={{ textAlign: 'center' }}>No Records Found</TableCell>
                      </TableRow>
                    }
                  </TableBody>
                </Table>
              </TableContainer>
            </AccordionDetails>
          </Accordion>

          {/* Task assign by manager Title Modal */}
          <Dialog
            open={taskAssignTitleModal}
            onClose={() => setTaskAssignTitleModal(false)}
          >
            <DialogTitle>Task Assigned By Manager and Pending</DialogTitle>
            <DialogContent>
              <p><strong>Title: </strong> {taskAssignTitleDetail?.ticketTitle} </p>                    
              <p><strong>Description: </strong> {taskAssignTitleDetail?.ticketDescription} </p>                    
            </DialogContent>
            <DialogActions>
              <Button
                onClick={() => {
                  setTaskAssignTitleModal(false);
                }}
                style={{ backgroundColor: "#F50057", color: "#fff" }}
                variant="contained"
              >
                Close
              </Button>
            </DialogActions>
          </Dialog>

          {/* Resolve Dialog */}

          <Fragment>
            <Dialog
              open={viewConfirmationDialog}
              keepMounted
              onClose={() => setViewConfirmationDialog(false)}
              aria-labelledby="alert-dialog-slide-title"
              aria-describedby="alert-dialog-slide-description"
            >
              <Card>
                <CardActionArea className={classes.cardDialog}>
                  <CardContent className={classes.cardDialog}>
                    <span style={{ fontWeight: "600", textAlign: "center", fontSize: "15px", marginRight: "10px" }}>Internal Ticket Id:</span>
                    <span style={{ fontSize: "15px" }}>{resolveIssueData?.uniqueTicketNo}</span> <br /><br />
                    <span style={{ fontWeight: "600", textAlign: "center", fontSize: "15px", marginRight: "10px" }}>Title:</span>
                    <span style={{ fontSize: "15px" }}>{resolveIssueData?.ticketTitle}</span> <br /><br />
                    <span style={{ fontWeight: "600", textAlign: "center", fontSize: "15px", marginRight: "10px" }}>Attachement:</span>
                    <span style={{ fontSize: "15px" }}>
                    {resolveIssueData && 
                      resolveIssueData.attachedFiles && 
                      resolveIssueData.attachedFiles.length > 0 && 
                      resolveIssueData.attachedFiles[0].trim() !== "" ? (
                          <DownloadOutlined
                            onClick={() => window.open(resolveIssueData.attachedFiles[0])}
                            style={{ color: "green", cursor: "pointer", fontWeight: "bold", fontSize: '24px' }}
                          />
                        ) : (
                          "No Attachment"
                        )
                      }
                      </span> <br /><br />
                    <Typography
                      variant="body2"
                      color="textSecondary"
                      component="p"
                    >
                      Click confirm to Resolve this Internal Ticket
                    </Typography>
                  </CardContent>
                </CardActionArea>
                <CardActions>
                  <TextField
                    id="remarks"
                    name="remarks"
                    label="Remarks"
                    type="text"
                    value={remarks}
                    onChange={(e) => setRemarks(e.target.value)}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    fullWidth
                    className={classes.textField}
                  />
                </CardActions>
                <CardActions style={{ justifyContent: 'right' }}>
                  <Button
                    onClick={handleCancel}
                    style={{ backgroundColor: "#F50057", color: "#fff" }}
                    variant="contained"
                  >
                    Cancel
                  </Button>
                  <Button
                    style={{ backgroundColor: "#F47E46", color: "#fff" }}
                    onClick={handleResolveConfirm}
                    variant="contained"
                  >
                    Confirm
                  </Button>
                </CardActions>
              </Card>
            </Dialog>
          </Fragment>

          {/* 3. Reminders Due */}
          <Accordion
            expanded={isExpanded.reminderDueExpand}
            onChange={(event, expanded) =>
              handleAccordionChange(event, expanded, "reminderDueExpand")
            }
            className={reminderDueData?.length > 0 ? classes.tableBackground : ''}         
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
              id="panel1a-header"
            >
              <Typography className={classes.heading}>
                Reminders Due {`(${reminderDueData?.length})`}
              </Typography>
            </AccordionSummary>
            <AccordionDetails style={{ padding: 0 }}>
              <TableContainer component={Paper}>
                <Table
                  className={classes.table}
                  stickyHeader
                  aria-label="sticky table"
                >
                  <TableHead>
                    <TableRow>
                      <TableCell className={classes.cellStyle}>
                        Sl No.
                      </TableCell>
                      <TableCell className={classes.cellStyle}>
                        Lead no
                      </TableCell>
                      <TableCell className={classes.cellStyle}>
                        Cx Name
                      </TableCell>
                      <TableCell className={classes.cellStyle}>
                        Current Stage
                      </TableCell>
                      <TableCell className={classes.cellStyle}>
                        Reminder Due Date
                      </TableCell>
                      <TableCell className={classes.cellStyle}>
                        Reminder Details
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {reminderDueData?.length > 0 ?
                      reminderDueData?.map((item, index) => (
                        <TableRow key={index}>
                          <TableCell
                            component="th"
                            style={{ padding: 10, textAlign: "center" }}
                          >
                            {index + 1}
                          </TableCell>
                          <TableCell
                            component="th"
                            style={{ padding: 10, textAlign: "center" }}
                          >
                            {item?.lead_no ? (
                              <Link
                                to={`/project-logs/${item?._id}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{
                                  color: "#000",
                                  textDecoration: "underline",
                                  textAlign: "center",
                                }}
                              >
                                {item?.lead_no}
                              </Link>
                            ) : (
                              "NA"
                            )}
                          </TableCell>
                          <TableCell
                            component="th"
                            style={{ padding: 10, textAlign: "center" }}
                          >
                            {item?.customerId?.name}
                          </TableCell>
                          <TableCell
                            component="th"
                            style={{ padding: 10, textAlign: "center" }}
                          >
                            {item?.currentStage}
                          </TableCell>
                          <TableCell
                            component="th"
                            style={{ padding: 10, textAlign: "center" }}
                          >
                            {item?.reminderDate ? moment(item?.reminderDate).format(
                              "DD-MM-YYYY"
                            ): '-'}
                          </TableCell>
                          <TableCell
                              onClick={() => handleReminderDueTitle(item)}
                              component="th"
                              style={{ padding: 10, textAlign: "center", textDecoration: 'underline', cursor: 'pointer' }}
                          >
                            {item?.notes}
                          </TableCell>
                        </TableRow>
                      ))
                      : 
                      <TableRow>
                        <TableCell colSpan={7} style={{ textAlign: 'center' }}>No Records Found</TableCell>
                      </TableRow>
                    }
                  </TableBody>
                </Table>
              </TableContainer>
            </AccordionDetails>
          </Accordion>

          {/* Reminder Due Title Modal */}
          <Dialog
            open={reminderDueTitleModal}
            onClose={() => setReminderDueTitleModal(false)}
          >
            <DialogTitle>Reminder Due Details</DialogTitle>
            <DialogContent>
              <Card>
                <CardActionArea className={classes.cardDialog}>
                  <CardContent className={classes.cardDialog}>
                    <span style={{ fontWeight: "600", textAlign: "center", fontSize: "15px", marginRight: "10px" }}>Notes - </span>
                    <span style={{ fontSize: "15px" }}>{reminderDueTitleDetail?.notes}</span> <br /><br />
                    <span style={{ fontWeight: "600", textAlign: "center", fontSize: "15px", marginRight: "10px" }}>Reminder Date - </span>
                    <span style={{ fontSize: "15px" }}>{reminderDueTitleDetail?.reminderDate ? moment(reminderDueTitleDetail?.reminderDate).format('DD-MM-YYYY'): '-'}</span> <br /><br />
                    <span style={{ fontWeight: "600", textAlign: "center", fontSize: "15px", marginRight: "10px" }}>Attachement - </span>
                    <span style={{ fontSize: "15px" }}>
                    {reminderDueTitleDetail && reminderDueTitleDetail?.s3Location && reminderDueTitleDetail?.s3Location.length > 0 ? (
                        <DownloadOutlined
                          onClick={() => window.open(reminderDueTitleDetail?.s3Location[0])}
                          style={{ color: "green", cursor: "pointer", fontWeight: "bold", fontSize: '24px' }}
                        />
                      ) : (
                        "No Attachment"
                      )}
                      </span> 
                  </CardContent>
                </CardActionArea>
              </Card>
              
            </DialogContent>
            <DialogActions>
              <Button
                onClick={() => {
                  setReminderDueTitleModal(false);
                }}
                style={{ backgroundColor: "#F50057", color: "#fff" }}
                variant="contained"
              >
                Cancel
              </Button>
              <Button
                onClick={() => {
                  handleClose(reminderDueTitleDetail);
                }}
                style={{ backgroundColor: "#F47E46", color: "#fff" }}
                variant="contained"
              >
                Close Reminder
              </Button>
            </DialogActions>
          </Dialog>

          {/* 4. Reminders- Today */}
          <Accordion
            expanded={isExpanded.reminderTodayExpand}
            onChange={(event, expanded) =>
              handleAccordionChange(event, expanded, "reminderTodayExpand")
            }
            className={reminderTodayData?.length > 0 ? classes.tableBackground : ''}         
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
              id="panel1a-header"
            >
              <Typography className={classes.heading}>
                Reminders Today {`(${reminderTodayData?.length})`}
              </Typography>
            </AccordionSummary>
            <AccordionDetails style={{ padding: 0 }}>
              <TableContainer component={Paper}>
                <Table
                  className={classes.table}
                  stickyHeader
                  aria-label="sticky table"
                >
                  <TableHead>
                    <TableRow>
                      <TableCell className={classes.cellStyle}>
                        Sl No.
                      </TableCell>
                      <TableCell className={classes.cellStyle}>
                        Lead no
                      </TableCell>
                      <TableCell className={classes.cellStyle}>
                        Cx Name
                      </TableCell>
                      <TableCell className={classes.cellStyle}>
                        Current Stage
                      </TableCell>
                      <TableCell className={classes.cellStyle}>
                        Reminder Due Date
                      </TableCell>
                      <TableCell className={classes.cellStyle}>
                        Reminder Details
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {reminderTodayData?.length > 0 ?
                      reminderTodayData?.map((item, index) => (
                        <TableRow key={index}>
                          <TableCell
                            component="th"
                            style={{ padding: 10, textAlign: "center" }}
                          >
                            {index + 1}
                          </TableCell>
                          <TableCell
                            component="th"
                            style={{ padding: 10, textAlign: "center" }}
                          >
                            {item?.lead_no ? (
                              <Link
                                to={`/project-logs/${item?._id}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{
                                  color: "#000",
                                  textDecoration: "underline",
                                  textAlign: "center",
                                }}
                              >
                                {item?.lead_no}
                              </Link>
                            ) : (
                              "NA"
                            )}
                          </TableCell>
                          <TableCell
                            component="th"
                            style={{ padding: 10, textAlign: "center" }}
                          >
                            {item?.customerId?.name}
                          </TableCell>
                          <TableCell
                            component="th"
                            style={{ padding: 10, textAlign: "center" }}
                          >
                            {item?.currentStage}
                          </TableCell>
                          <TableCell
                            component="th"
                            style={{ padding: 10, textAlign: "center" }}
                          >
                            {item?.reminderDate ? moment(item?.reminderDate).format(
                              "DD-MM-YYYY"
                            ): '-'}
                          </TableCell>
                          <TableCell
                            component="th"
                            onClick={() =>
                              handleReminderTodayTitle(item)
                            }
                            style={{ padding: 10, textAlign: "center", cursor: 'pointer', textDecoration: 'underline' }}
                          >
                             {item?.notes}
                          </TableCell>
                        </TableRow>
                      ))
                      : 
                      <TableRow>
                        <TableCell colSpan={7} style={{ textAlign: 'center' }}>No Records Found</TableCell>
                      </TableRow>
                      }
                  </TableBody>
                </Table>
              </TableContainer>
            </AccordionDetails>
          </Accordion>

          {/* Reminder Today Title Modal */}
          <Dialog
            open={reminderTodayTitleModal}
            onClose={() => setReminderTodayTitleModal(false)}
          >
            <DialogTitle>Reminder Today Details</DialogTitle>
            <DialogContent>
            <Card>
                <CardActionArea className={classes.cardDialog}>
                  <CardContent className={classes.cardDialog}>
                    <span style={{ fontWeight: "600", textAlign: "center", fontSize: "15px", marginRight: "10px" }}>Notes - </span>
                    <span style={{ fontSize: "15px" }}>{reminderTodaytTitleDetail?.notes}</span> <br /><br />
                    <span style={{ fontWeight: "600", textAlign: "center", fontSize: "15px", marginRight: "10px" }}>Reminder Date - </span>
                    <span style={{ fontSize: "15px" }}>{reminderTodaytTitleDetail?.reminderDate ? moment(reminderTodaytTitleDetail?.reminderDate).format('DD-MM-YYYY'): '-'}</span> <br /><br />
                    <span style={{ fontWeight: "600", textAlign: "center", fontSize: "15px", marginRight: "10px" }}>Attachement - </span>
                    <span style={{ fontSize: "15px" }}>
                    {reminderTodaytTitleDetail && reminderTodaytTitleDetail?.s3Location && reminderTodaytTitleDetail?.s3Location.length > 0 ? (
                        <DownloadOutlined
                          onClick={() => window.open(reminderTodaytTitleDetail?.s3Location[0])}
                          style={{ color: "green", cursor: "pointer", fontWeight: "bold", fontSize: '24px' }}
                        />
                      ) : (
                        "No Attachment"
                      )}
                      </span> 
                  </CardContent>
                </CardActionArea>
              </Card>
            </DialogContent>
            <DialogActions>
              <Button
                onClick={() => {
                  setReminderTodayTitleModal(false);
                }}
                style={{ backgroundColor: "#F50057", color: "#fff" }}
                variant="contained"
              >
                Close
              </Button>
              <Button
                onClick={() => {
                  handleClose(reminderTodaytTitleDetail);
                }}
                style={{ backgroundColor: "#F47E46", color: "#fff" }}
                variant="contained"
              >
                Close Reminder
              </Button>
            </DialogActions>
          </Dialog>

          {/* 5. Reminders- Tomorrow */}
          <Accordion
            expanded={isExpanded.reminderTomoExpand}
            onChange={(event, expanded) =>
              handleAccordionChange(event, expanded, "reminderTomoExpand")
            }
          >
            <Tooltip title={(disableMenu.taskAssigned > 0 || disableMenu.reminderDue > 0 || disableMenu.reminderToday > 0 || disableMenu.leadReceived > 0) ? "This section is disabled because other tasks are pending." : ""} arrow>
              <div>
                <AccordionSummary
                  disabled={disableMenu.taskAssigned > 0 || disableMenu.reminderDue > 0 || disableMenu.reminderToday > 0 || disableMenu.leadReceived > 0}
                  // expandIcon={<ExpandMoreIcon />}
                  expandIcon={disableMenu.taskAssigned > 0 || disableMenu.reminderDue > 0 || disableMenu.reminderToday > 0 || disableMenu.leadReceived > 0 ? <LockIcon /> : <ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                >
                  <Typography className={classes.heading}>
                    Reminders Tomorrow  {`(${reminderTmwData?.length})`}
                  </Typography>
                </AccordionSummary>
              </div>
            </Tooltip>
            <AccordionDetails style={{ padding: 0 }}>
              <TableContainer component={Paper}>
                <Table
                  className={classes.table}
                  stickyHeader
                  aria-label="sticky table"
                >
                  <TableHead>
                    <TableRow>
                      <TableCell className={classes.cellStyle}>
                        Sl No.
                      </TableCell>
                      <TableCell className={classes.cellStyle}>
                        Lead no
                      </TableCell>
                      <TableCell className={classes.cellStyle}>
                        Cx Name
                      </TableCell>
                      <TableCell className={classes.cellStyle}>
                        Current Stage
                      </TableCell>
                      <TableCell className={classes.cellStyle}>
                        Reminder Due Date
                      </TableCell>
                      <TableCell className={classes.cellStyle}>
                        Reminder Details
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {reminderTmwData?.length > 0 ?
                      reminderTmwData?.map((item, index) => (
                        <TableRow key={index}>
                          <TableCell
                            component="th"
                            style={{ padding: 10, textAlign: "center" }}
                          >
                            {index + 1}
                          </TableCell>
                          <TableCell
                            component="th"
                            style={{ padding: 10, textAlign: "center" }}
                          >
                            {item?.lead_no ? (
                              <Link
                                to={`/project-logs/${item?._id}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{
                                  color: "#000",
                                  textDecoration: "underline",
                                  textAlign: "center",
                                }}
                              >
                                {item?.lead_no}
                              </Link>
                            ) : (
                              "NA"
                            )}
                          </TableCell>
                          <TableCell
                            component="th"
                            style={{ padding: 10, textAlign: "center" }}
                          >
                            {item?.customerId?.name}
                          </TableCell>
                          <TableCell
                            component="th"
                            style={{ padding: 10, textAlign: "center" }}
                          >
                            {item?.currentStage}
                          </TableCell>
                          <TableCell
                            component="th"
                            style={{ padding: 10, textAlign: "center" }}
                          >
                            { item?.reminderDate ? moment(item?.reminderDate).format(
                              "DD-MM-YYYY"
                            ): '-'}
                          </TableCell>
                          <TableCell
                            component="th"
                            onClick={() => handleReminderTmwTitle(item)}
                            style={{ padding: 10, textAlign: "center", textDecoration: 'underline', cursor: 'pointer' }}
                          >
                            {item?.notes}
                          </TableCell>
                        </TableRow>
                      ))
                      : 
                      <TableRow>
                        <TableCell colSpan={7} style={{ textAlign: 'center' }}>No Records Found</TableCell>
                      </TableRow>
                    }
                  </TableBody>
                </Table>
              </TableContainer>
            </AccordionDetails>
          </Accordion>

          {/* Reminder tomorrow Title Modal */}
          <Dialog
            open={reminderTmwTitleModal}
            onClose={() => setReminderTmwTitleModal(false)}
          >
            <DialogTitle>Reminder Tomorrow Details</DialogTitle>
            <DialogContent>
            <Card>
                <CardActionArea className={classes.cardDialog}>
                  <CardContent className={classes.cardDialog}>
                    <span style={{ fontWeight: "600", textAlign: "center", fontSize: "15px", marginRight: "10px" }}>Notes - </span>
                    <span style={{ fontSize: "15px" }}>{reminderTmwTitleDetail?.notes}</span> <br /><br />
                    <span style={{ fontWeight: "600", textAlign: "center", fontSize: "15px", marginRight: "10px" }}>Reminder Date - </span>
                    <span style={{ fontSize: "15px" }}>{reminderTmwTitleDetail?.reminderDate ? moment(reminderTmwTitleDetail?.reminderDate).format('DD-MM-YYYY'): '-'}</span> <br /><br />
                    <span style={{ fontWeight: "600", textAlign: "center", fontSize: "15px", marginRight: "10px" }}>Attachement - </span>
                    <span style={{ fontSize: "15px" }}>
                    {reminderTmwTitleDetail && reminderTmwTitleDetail?.s3Location && reminderTmwTitleDetail?.s3Location.length > 0 ? (
                        <DownloadOutlined
                          onClick={() => window.open(reminderTmwTitleDetail?.s3Location[0])}
                          style={{ color: "green", cursor: "pointer", fontWeight: "bold", fontSize: '24px' }}
                        />
                      ) : (
                        "No Attachment"
                      )}
                      </span> 
                  </CardContent>
                </CardActionArea>
              </Card>
              
            </DialogContent>
            <DialogActions>
              <Button
                onClick={() => {
                  setReminderTmwTitleModal(false);
                }}
                style={{ backgroundColor: "#F50057", color: "#fff" }}
                variant="contained"
              >
                Close
              </Button>
              <Button
                onClick={() => {
                  handleClose(reminderTmwTitleDetail);
                }}
                style={{ backgroundColor: "#F47E46", color: "#fff" }}
                variant="contained"
              >
                Close Reminder
              </Button>
            </DialogActions>
          </Dialog>

          {/* 6. Tasks assigned by Managers (ASM/SM/DGM/CH) and not due */}
          <Accordion
            expanded={isExpanded.taskAssignedNotDueExpand}
            onChange={(event, expanded) =>
              handleAccordionChange(event, expanded, "taskAssignedNotDueExpand")
            }
          >
            <Tooltip title={(disableMenu.taskAssigned > 0 || disableMenu.reminderDue > 0 || disableMenu.reminderToday > 0 || disableMenu.leadReceived > 0) ? "This section is disabled because other tasks are pending." : ""} arrow>
              <div>
                <AccordionSummary
                  // expandIcon={<ExpandMoreIcon />}
                  expandIcon={disableMenu.taskAssigned > 0 || disableMenu.reminderDue > 0 || disableMenu.reminderToday > 0 || disableMenu.leadReceived > 0 ? <LockIcon /> : <ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                  disabled={disableMenu.taskAssigned > 0 || disableMenu.reminderDue > 0 || disableMenu.reminderToday > 0 || disableMenu.leadReceived > 0}
                >
                  <Typography className={classes.heading}>
                    Tasks assigned by Managers (ASM/SM/DGM/CH) {`(${count?.taskAssignedNotDue})`}
                  </Typography>
                </AccordionSummary>
              </div>
            </Tooltip>
            <AccordionDetails style={{ padding: 0 }}>
              <TableContainer component={Paper}>
                <Table
                  className={classes.table}
                  stickyHeader
                  aria-label="sticky table"
                >
                  <TableHead>
                    <TableRow>
                      <TableCell className={classes.cellStyle}>
                        Sl No.
                      </TableCell>
                      <TableCell className={classes.cellStyle}>
                        Lead no
                      </TableCell>
                      <TableCell className={classes.cellStyle}>
                        Cx Name
                      </TableCell>
                      <TableCell className={classes.cellStyle}>
                        Assigned By
                      </TableCell>
                      <TableCell className={classes.cellStyle}>
                        Task Due Date
                      </TableCell>
                      <TableCell className={classes.cellStyle} colSpan={2}>
                        Task Details
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {taskAssignedNotDueData?.length > 0 ?
                      taskAssignedNotDueData?.map((item, index) => (
                        <TableRow key={index}>
                          <TableCell
                            component="th"
                            style={{ padding: 10, textAlign: "center" }}
                          >
                            {index + 1}
                          </TableCell>
                          <TableCell
                            component="th"
                            style={{ padding: 10, textAlign: "center" }}
                          >
                            {item?.lead_no ? (
                              <Link
                                to={`/project-logs/${item?.leadId}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{
                                  color: "#000",
                                  textDecoration: "underline",
                                  textAlign: "center",
                                }}
                              >
                                {item?.lead_no}
                              </Link>
                            ) : (
                              "NA"
                            )}
                          </TableCell>
                          <TableCell
                            component="th"
                            style={{ padding: 10, textAlign: "center" }}
                          >
                            {item?.customerId?.name}
                          </TableCell>
                          <TableCell
                            component="th"
                            style={{ padding: 10, textAlign: "center" }}
                          >
                            {item?.taskCreatedBy?.name}
                          </TableCell>
                          <TableCell
                            component="th"
                            style={{ padding: 10, textAlign: "center" }}
                          >
                            {item?.expectedClosureDate ? moment(item?.expectedClosureDate).format(
                              "DD-MM-YYYY"
                            ): '-'}
                          </TableCell>
                          {/* <TableCell
                            component="th"
                            onClick={() =>
                              handleTaskAssignNotDueTitle(item)
                            }
                            style={{ textAlign: "center", cursor: "pointer", textDecoration: "underline", }}
                          >
                            {item?.ticketTitle}
                          </TableCell> */}
                          <TableCell
                            component="th"
                            onClick={() =>
                              handleTaskAssignNotDueTitle(item)
                            }
                            style={{ textAlign: "center", cursor: "pointer", textDecoration: "underline", }}
                          >
                            {item?.ticketTitle}
                          </TableCell>
                          <TableCell component="th">
                             {!(item?.status === "Closed" || item?.status === "Resolved") && (
                                <CenterFocusWeakIcon
                                  className={classes.handOnHover}
                                  style={{ color: '#3299d8' }}
                                  onClick={() => {
                                    resolveIssue(item);
                                  }}
                                  titleAccess="Resolve Issue"
                                />
                             )}
                          </TableCell>
                        </TableRow>
                      ))
                      : 
                      <TableRow>
                        <TableCell colSpan={6} style={{ textAlign: 'center' }}>No Records Found</TableCell>
                      </TableRow>
                    }
                  </TableBody>
                </Table>
              </TableContainer>
            </AccordionDetails>
          </Accordion>

          {/* Task assign not due by manager Title Modal */}
          <Dialog
            open={taskAssignNotDueTitleModal}
            onClose={() => setTaskAssignNotDueTitleModal(false)}
          >
            <DialogTitle>Task Assigned By Manager, Not Due</DialogTitle>
            <DialogContent>
              <p><strong>Title: </strong> {taskAssignNotDueTitleDetail?.ticketTitle} </p><br/>
              <p><strong>Description: </strong> {taskAssignNotDueTitleDetail?.ticketDescription} </p><br/>
              <p><strong>Status: </strong> {taskAssignNotDueTitleDetail?.status} </p><br/>
              <p><strong>Attachment: </strong> 
              {taskAssignNotDueTitleDetail?.attachedFiles?.length > 0 &&  taskAssignNotDueTitleDetail?.attachedFiles[0]?.trim() !== "" ?  <DownloadOutlined
                  onClick={() => window.open(taskAssignNotDueTitleDetail?.attachedFiles[0])}
                  style={{ color: "green", cursor: "pointer", fontWeight: "bold", fontSize: '24px' }}
                /> :'No Attachment'
                }
              </p>
            </DialogContent>
            <DialogActions>
              <Button
                onClick={() => {
                  setTaskAssignNotDueTitleModal(false);
                }}
                style={{ backgroundColor: "#F50057", color: "#fff" }}
                variant="contained"
              >
                Close
              </Button>
            </DialogActions>
          </Dialog>

          {/* 8. Leads where reminders are not set and required to be set */}
          <Accordion
            expanded={isExpanded.leadReminderNotSetExpand}
            onChange={(event, expanded) =>
              handleAccordionChange(event, expanded, "leadReminderNotSetExpand")
            }
          >
            <Tooltip title={(disableMenu.taskAssigned > 0 || disableMenu.reminderDue > 0 || disableMenu.reminderToday > 0 || disableMenu.leadReceived > 0) ? "This section is disabled because other tasks are pending." : ""} arrow>
              <div>
                <AccordionSummary
                  disabled={disableMenu.taskAssigned > 0 || disableMenu.reminderDue > 0 || disableMenu.reminderToday > 0 || disableMenu.leadReceived > 0}
                  expandIcon={disableMenu.taskAssigned > 0 || disableMenu.reminderDue > 0 || disableMenu.reminderToday > 0 || disableMenu.leadReceived > 0 ? <LockIcon /> : <ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                >
                  <Typography className={classes.heading}>
                    Leads where reminders are not set and required to be set  {`(${count?.leadReminderNotSet})`}
                  </Typography>
                </AccordionSummary>
              </div>
            </Tooltip>
            <AccordionDetails style={{ padding: 0 }}>
              <TableContainer component={Paper}>
                <Table
                  className={classes.table}
                  stickyHeader
                  aria-label="sticky table"
                >
                  <TableHead>
                    <TableRow>
                      <TableCell className={classes.cellStyle}>
                        Sl No.
                      </TableCell>
                      <TableCell className={classes.cellStyle}>
                        Lead no
                      </TableCell>
                      <TableCell className={classes.cellStyle}>
                        Cx Name
                      </TableCell>
                      <TableCell className={classes.cellStyle}>
                        Current Stage
                      </TableCell>
                      <TableCell className={classes.cellStyle}>
                        Lead Created Date
                      </TableCell>
                      <TableCell className={classes.cellStyle}>
                        Last Activity Date
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {leadReminderNotSetData?.length > 0 ?
                      leadReminderNotSetData?.map((item, index) => (
                        <TableRow key={index}>
                          <TableCell
                            component="th"
                            style={{ padding: 10, textAlign: "center" }}
                          >
                            {index + 1}
                          </TableCell>
                          <TableCell
                            component="th"
                            style={{ padding: 10, textAlign: "center" }}
                          >
                            {item?.lead_no ? (
                              <Link
                                to={`/project-logs/${item?._id}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{
                                  color: "#000",
                                  textDecoration: "underline",
                                  textAlign: "center",
                                }}
                              >
                                {item?.lead_no}
                              </Link>
                            ) : (
                              "NA"
                            )}
                          </TableCell>
                          <TableCell
                            component="th"
                            style={{ padding: 10, textAlign: "center" }}
                          >
                            {item?.customerId?.name}
                          </TableCell>
                          <TableCell
                            component="th"
                            style={{ padding: 10, textAlign: "center" }}
                          >
                            {item?.currentStage}
                          </TableCell>
                          <TableCell
                            component="th"
                            style={{ padding: 10, textAlign: "center" }}
                          >
                            {item?.createdAt ? moment(item?.createdAt).format("DD-MM-YYYY"): '-'}
                          </TableCell>
                          <TableCell
                            component="th"
                            style={{ padding: 10, textAlign: "center" }}
                          >
                            {item?.lastActivityDate ? moment(item?.lastActivityDate).format(
                              "DD-MM-YYYY"
                            ) : '-'}
                          </TableCell>
                        </TableRow>
                      ))
                      : 
                      <TableRow>
                        <TableCell colSpan={6} style={{ textAlign: 'center' }}>No Records Found</TableCell>
                      </TableRow>
                    }
                  </TableBody>
                </Table>
              </TableContainer>
            </AccordionDetails>
          </Accordion>

          {/* 9. Projected deals not closed till today (projected vs acv) */}
          <Accordion
            expanded={isExpanded.projectNotCloseExpand}
            onChange={(event, expanded) =>
              handleAccordionChange(event, expanded, "projectNotCloseExpand")
            }
          >
            <Tooltip title={(disableMenu.taskAssigned > 0 || disableMenu.reminderDue > 0 || disableMenu.reminderToday > 0 || disableMenu.leadReceived > 0) ? "This section is disabled because other tasks are pending." : ""} arrow>
              <div>
                <AccordionSummary
                  disabled={disableMenu.taskAssigned > 0 || disableMenu.reminderDue > 0 || disableMenu.reminderToday > 0 || disableMenu.leadReceived > 0}
                  expandIcon={disableMenu.taskAssigned > 0 || disableMenu.reminderDue > 0 || disableMenu.reminderToday > 0 || disableMenu.leadReceived > 0 ? <LockIcon /> : <ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                >
                  <Typography className={classes.heading}>
                    Projected deals not closed till today  {`(${count?.projectNotClose})`}
                  </Typography>
                </AccordionSummary>
              </div>
            </Tooltip>
            <AccordionDetails style={{ padding: 0 }}>
              <TableContainer component={Paper}>
                <Table
                  className={classes.table}
                  stickyHeader
                  aria-label="sticky table"
                >
                  <TableHead>
                    <TableRow>
                      <TableCell className={classes.cellStyle}>
                        Sl No.
                      </TableCell>
                      <TableCell className={classes.cellStyle}>
                        Lead no
                      </TableCell>
                      <TableCell className={classes.cellStyle}>
                        Cx Name
                      </TableCell>
                      <TableCell className={classes.cellStyle}>
                        Current Stage
                      </TableCell>
                      <TableCell className={classes.cellStyle}>
                        Expected SW date
                      </TableCell>
                      <TableCell className={classes.cellStyle}>
                        Last Activity Date
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {projectNotCloseData?.length > 0 ?
                      projectNotCloseData?.map((item, index) => (
                        <TableRow key={index}>
                          <TableCell
                            component="th"
                            style={{ padding: 10, textAlign: "center" }}
                          >
                            {index + 1}
                          </TableCell>
                          <TableCell
                            component="th"
                            style={{ padding: 10, textAlign: "center" }}
                          >
                            {item?.lead_no ? (
                              <Link
                                to={`/project-logs/${item?._id}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{
                                  color: "#000",
                                  textDecoration: "underline",
                                  textAlign: "center",
                                }}
                              >
                                {item?.lead_no}
                              </Link>
                            ) : (
                              "NA"
                            )}
                          </TableCell>
                          <TableCell
                            component="th"
                            style={{ padding: 10, textAlign: "center" }}
                          >
                            {item?.customerId?.name}
                          </TableCell>
                          <TableCell
                            component="th"
                            style={{ padding: 10, textAlign: "center" }}
                          >
                            {item?.currentStage}
                          </TableCell>
                          <TableCell
                            component="th"
                            style={{ padding: 10, textAlign: "center" }}
                          >
                            {item?.expectedSalesclosureDate ? moment(item?.expectedSalesclosureDate).format(
                              "DD-MM-YYYY"
                            ): '-'}
                          </TableCell>
                          <TableCell
                            component="th"
                            style={{ padding: 10, textAlign: "center" }}
                          >
                            {item?.lastActivityDate ? moment(item?.lastActivityDate).format(
                              "DD-MM-YYYY"
                            ): '-'}
                          </TableCell>
                        </TableRow>
                      ))
                      : 
                      <TableRow>
                        <TableCell colSpan={6} style={{ textAlign: 'center' }}>No Records Found</TableCell>
                      </TableRow>
                    }
                  </TableBody>
                </Table>
              </TableContainer>
            </AccordionDetails>
          </Accordion>

          {/* 10. Today's and tomorrow's expected closures */}
          <Accordion
            expanded={isExpanded.todayTomoExpectedExpand}
            onChange={(event, expanded) =>
              handleAccordionChange(event, expanded, "todayTomoExpectedExpand")
            }
          >
            <Tooltip title={(disableMenu.taskAssigned > 0 || disableMenu.reminderDue > 0 || disableMenu.reminderToday > 0 || disableMenu.leadReceived > 0) ? "This section is disabled because other tasks are pending." : ""} arrow>
              <div>
                <AccordionSummary
                  expandIcon={disableMenu.taskAssigned > 0 || disableMenu.reminderDue > 0 || disableMenu.reminderToday > 0 || disableMenu.leadReceived > 0 ? <LockIcon /> : <ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                  disabled={disableMenu.taskAssigned > 0 || disableMenu.reminderDue > 0 || disableMenu.reminderToday > 0 || disableMenu.leadReceived > 0}
                >
                  <Typography className={classes.heading}>
                    Tomorrow's expected closures  {`(${count?.todayTomoExpected})`}
                  </Typography>
                </AccordionSummary>
              </div>
            </Tooltip>
            <AccordionDetails style={{ padding: 0 }}>
              <TableContainer component={Paper}>
                <Table
                  className={classes.table}
                  stickyHeader
                  aria-label="sticky table"
                >
                  <TableHead>
                    <TableRow>
                      <TableCell className={classes.cellStyle}>
                        Sl No.
                      </TableCell>
                      <TableCell className={classes.cellStyle}>
                        Lead no
                      </TableCell>
                      <TableCell className={classes.cellStyle}>
                        Cx Name
                      </TableCell>
                      <TableCell className={classes.cellStyle}>
                        Current Stage
                      </TableCell>
                      <TableCell className={classes.cellStyle}>
                        Expected SW date
                      </TableCell>
                      <TableCell className={classes.cellStyle}>
                        Last Activity Date
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {todayTomoExpectedData?.length > 0 ?
                      todayTomoExpectedData?.map((item, index) => (
                        <TableRow key={index}>
                          <TableCell
                            component="th"
                            style={{ padding: 10, textAlign: "center" }}
                          >
                            {index + 1}
                          </TableCell>
                          <TableCell
                            component="th"
                            style={{ padding: 10, textAlign: "center" }}
                          >
                            {item?.lead_no ? (
                              <Link
                                to={`/project-logs/${item?._id}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{
                                  color: "#000",
                                  textDecoration: "underline",
                                  textAlign: "center",
                                }}
                              >
                                {item?.lead_no}
                              </Link>
                            ) : (
                              "NA"
                            )}
                          </TableCell>
                          <TableCell
                            component="th"
                            style={{ padding: 10, textAlign: "center" }}
                          >
                            {item?.customerId?.name}
                          </TableCell>
                          <TableCell
                            component="th"
                            style={{ padding: 10, textAlign: "center" }}
                          >
                            {item?.currentStage}
                          </TableCell>
                          <TableCell
                            component="th"
                            style={{ padding: 10, textAlign: "center" }}
                          >
                            {item?.expectedSalesclosureDate ? moment(item?.expectedSalesclosureDate).format(
                              "DD-MM-YYYY"
                            ): '-'}
                          </TableCell>
                          <TableCell
                            component="th"
                            style={{ padding: 10, textAlign: "center" }}
                          >
                            {item?.lastActivityDate ? moment(item?.lastActivityDate).format(
                              "DD-MM-YYYY"
                            ) : '-'}
                          </TableCell>
                        </TableRow>
                      ))
                      : 
                      <TableRow>
                        <TableCell colSpan={6} style={{ textAlign: 'center' }}>No Records Found</TableCell>
                      </TableRow>
                    }
                  </TableBody>
                </Table>
              </TableContainer>
            </AccordionDetails>
          </Accordion>

          {/* 11. List of leads where you can close 80% of the lead */}
          <Accordion
            expanded={isExpanded.close80PerExpand}
            onChange={(event, expanded) =>
              handleAccordionChange(event, expanded, "close80PerExpand")
            }
          >
            <Tooltip title={(disableMenu.taskAssigned > 0 || disableMenu.reminderDue > 0 || disableMenu.reminderToday > 0 || disableMenu.leadReceived > 0) ? "This section is disabled because other tasks are pending." : ""} arrow>
              <div>
                <AccordionSummary
                  expandIcon={disableMenu.taskAssigned > 0 || disableMenu.reminderDue > 0 || disableMenu.reminderToday > 0 || disableMenu.leadReceived > 0 ? <LockIcon /> : <ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                  disabled={disableMenu.taskAssigned > 0 || disableMenu.reminderDue > 0 || disableMenu.reminderToday > 0 || disableMenu.leadReceived > 0}
                >
                  <Typography className={classes.heading}>
                    List of leads where you can close 80% of the lead  {`(${count?.close80Per})`}
                  </Typography>
                </AccordionSummary>
              </div>
            </Tooltip>
            <AccordionDetails style={{ padding: 0 }}>
              <TableContainer component={Paper}>
                <Table
                  className={classes.table}
                  stickyHeader
                  aria-label="sticky table"
                >
                  <TableHead>
                    <TableRow>
                      <TableCell className={classes.cellStyle}>
                        Sl No.
                      </TableCell>
                      <TableCell className={classes.cellStyle}>
                        Lead no
                      </TableCell>
                      <TableCell className={classes.cellStyle}>
                        Cx Name
                      </TableCell>
                      <TableCell className={classes.cellStyle}>
                        Current Stage
                      </TableCell>
                      <TableCell className={classes.cellStyle}>
                        Meeting Type
                      </TableCell>
                      <TableCell className={classes.cellStyle}>
                        Last Meeting Date
                      </TableCell>
                      <TableCell className={classes.cellStyle}>
                        Logs of meeting
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {close80PerData?.length > 0 ?
                    close80PerData?.sort((a, b) => new Date(b?.meetingWithCustomer?.meetingDate || 0) - new Date(a?.meetingWithCustomer?.meetingDate || 0)
                    )?.map((item, index) => (
                        <TableRow key={index}>
                          <TableCell
                            component="th"
                            style={{ padding: 10, textAlign: "center" }}
                          >
                            {index + 1}
                          </TableCell>
                          <TableCell
                            component="th"
                            style={{ padding: 10, textAlign: "center" }}
                          >
                            {item?.lead_no ? (
                              <Link
                                to={`/project-logs/${item?._id}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{
                                  color: "#000",
                                  textDecoration: "underline",
                                  textAlign: "center",
                                }}
                              >
                                {item?.lead_no}
                              </Link>
                            ) : (
                              "NA"
                            )}
                          </TableCell>
                          <TableCell
                            component="th"
                            style={{ padding: 10, textAlign: "center" }}
                          >
                            {item?.customerId?.name}
                          </TableCell>
                          <TableCell
                            component="th"
                            style={{ padding: 10, textAlign: "center" }}
                          >
                            {item?.currentStage}
                          </TableCell>
                          <TableCell
                            component="th"
                            style={{ padding: 10, textAlign: "center" }}
                          >
                            {item?.meetingWithCustomer?.meetingType
                              ? item.meetingWithCustomer.meetingType
                              : "NA"}
                          </TableCell>
                          <TableCell
                            component="th"
                            style={{ padding: 10, textAlign: "center" }}
                          >
                            {item?.meetingWithCustomer?.meetingDate
                              ? moment(
                                  item?.meetingWithCustomer?.meetingDate
                                ).format("DD-MM-YYYY")
                              : "-"}
                          </TableCell>
                          <TableCell
                            component="th"
                            style={{ padding: 10, textAlign: "center" }}
                          >
                            {
                              <InfoIcon
                                onClick={() =>
                                  handleMeetingTitleDetail(item._id)
                                }
                                style={{ cursor: "pointer", height: "18px" }}
                              />
                            }
                          </TableCell>
                        </TableRow>
                      ))
                      : 
                      <TableRow>
                        <TableCell colSpan={7} style={{ textAlign: 'center' }}>No Records Found</TableCell>
                      </TableRow>
                    }
                  </TableBody>
                </Table>
              </TableContainer>
            </AccordionDetails>
          </Accordion>

          {/* List of leads where you can close 80% of the lead Title Modal */}
          <Dialog
            open={close80TitleModal}
            onClose={() => setClose80TitleModal(false)}
          >
            <DialogTitle>Meeting Details</DialogTitle>
            <DialogContent>
              {close80TitleDetail && close80TitleDetail?.length > 0 ? (
                <ul>
                  {close80TitleDetail?.map((data, index) => (
                    <li key={index} style={{ marginBottom: "15px" }}>
                      <strong>Meeting Date: </strong>
                      {data?.meetingDate
                        ? moment(data.meetingDate).format("DD-MM-YYYY")
                        : "No date set"}
                      <br />
                      <strong>Meeting Type: </strong>
                      {data.meetingTypes.officeMeets.length > 0 ? 'Office Meet' : data.meetingTypes.residenceMeets.length > 0 ? 'Residence Meet' : ''} <br />
                    </li>
                  ))}
                </ul>
              ) : (
                <p> No meeting details available.</p>
              )}
            </DialogContent>
            <DialogActions>
              <Button
                onClick={() => {
                  setClose80TitleModal(false);
                }}
                style={{ backgroundColor: "#F50057", color: "#fff" }}
                variant="contained"
              >
                Close
              </Button>
            </DialogActions>
          </Dialog>

          {/* 12. Cx not called in last 2 days */}
          <Accordion
            expanded={isExpanded.cxNotCallExpand}
            onChange={(event, expanded) =>
              handleAccordionChange(event, expanded, "cxNotCallExpand")
            }
          >
            <Tooltip title={(disableMenu.taskAssigned > 0 || disableMenu.reminderDue > 0 || disableMenu.reminderToday > 0 || disableMenu.leadReceived > 0) ? "This section is disabled because other tasks are pending." : ""}>
              <div>
                <AccordionSummary
                  expandIcon={disableMenu.taskAssigned > 0 || disableMenu.reminderDue > 0 || disableMenu.reminderToday > 0 || disableMenu.leadReceived > 0 ? <LockIcon /> : <ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                  disabled={disableMenu.taskAssigned > 0 || disableMenu.reminderDue > 0 || disableMenu.reminderToday > 0 || disableMenu.leadReceived > 0}
                >
                  <Typography className={classes.heading}>
                    Leads not called in last 2 days {`(${count?.cxNotCall})`}
                  </Typography>
                </AccordionSummary>
              </div>
            </Tooltip>
            <AccordionDetails style={{ padding: 0 }}>
              <TableContainer component={Paper}>
                <Table
                  className={classes.table}
                  stickyHeader
                  aria-label="sticky table"
                >
                  <TableHead>
                    <TableRow>
                      <TableCell className={classes.cellStyle}>
                        Sl No.
                      </TableCell>
                      <TableCell className={classes.cellStyle}>
                        Lead no
                      </TableCell>
                      <TableCell className={classes.cellStyle}>
                        Cx Name
                      </TableCell>
                      <TableCell className={classes.cellStyle}>
                        Current Stage
                      </TableCell>
                      <TableCell className={classes.cellStyle}>
                        Expected SW date
                      </TableCell>
                      <TableCell className={classes.cellStyle}>
                        Last Activity Date
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                  {cxNotCallData?.length > 0 ?
                      cxNotCallData?.map((item, index) => (
                        <TableRow key={index}>
                          <TableCell
                            component="th"
                            style={{ padding: 10, textAlign: "center" }}
                          >
                            {index + 1}
                          </TableCell>
                          <TableCell
                            component="th"
                            style={{ padding: 10, textAlign: "center" }}
                          >
                            {item?.lead_no ? (
                              <Link
                                to={`/project-logs/${item?._id}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{
                                  color: "#000",
                                  textDecoration: "underline",
                                  textAlign: "center",
                                }}
                              >
                                {item?.lead_no}
                              </Link>
                            ) : (
                              "NA"
                            )}
                          </TableCell>
                          <TableCell
                            component="th"
                            style={{ padding: 10, textAlign: "center" }}
                          >
                            {item?.customerId?.name}
                          </TableCell>
                          <TableCell
                            component="th"
                            style={{ padding: 10, textAlign: "center" }}
                          >
                            {item?.currentStage}
                          </TableCell>
                          <TableCell
                            component="th"
                            style={{ padding: 10, textAlign: "center" }}
                          >
                            {item?.expectedSalesclosureDate ? moment(item?.expectedSalesclosureDate).format(
                              "DD-MM-YYYY"
                            ): '-'}
                          </TableCell>
                          <TableCell
                            component="th"
                            style={{ padding: 10, textAlign: "center" }}
                          >
                            {item?.lastActivityDate ? moment(item?.lastActivityDate).format(
                              "DD-MM-YYYY"
                            ): '-'}
                          </TableCell>
                        </TableRow>
                      ))
                      : 
                      <TableRow>
                        <TableCell colSpan={6} style={{ textAlign: 'center' }}>No Records Found</TableCell>
                      </TableRow>
                    }
                  </TableBody>
                </Table>
              </TableContainer>
            </AccordionDetails>
          </Accordion>

          {/* Reminder CLose Functionality */}
          <Dialog open={reminderCloseDialog} onClose={() => setReminderCloseDialog(false)}>
            <DialogTitle>Enter Close Reminder Remarks</DialogTitle>
            <DialogContent>
              <TextField
                autoFocus
                margin="dense"
                id="remarks"
                label="Remarks"
                type="text"
                fullWidth
                style={{ width: 400 }}
                value={reminderCloseRemark}
                onChange={(e) => setReminderCloseRemark(e.target.value)}
              />
            </DialogContent>
            <DialogActions>
              <Button onClick={() => setReminderCloseDialog(false)} color="primary" variant="outlined">
                Cancel
              </Button>
              <Button onClick={handleReminderCloseButton} color="secondary" variant="outlined">
                Submit
              </Button>
            </DialogActions>
          </Dialog>
        </Paper>
      </>
    </div>
  );
};

export default connect(null, { setLoading, setSnackInfo })(SalesUserHomePage);
